import { useEffect } from "react"
import favicon from "../../../assets/images/shariehandslogo.png"

const useFavicon = () => {
  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']") || document.createElement("link")
    link.rel = "icon"
    link.href = favicon
    document.head.appendChild(link)
  }, [favicon])
}
export default useFavicon
